import {
  Box,
  Button,
  ButtonProps,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  PortalProps,
  useDisclosure,
} from "@chakra-ui/react";
import { Portal as ChakraPortal, useModalContext } from "@chakra-ui/react";
import { PropsWithChildren, useRef } from "react";

import { InfoIcon } from "../../icons/infoIcon";

import { ModalProps, RanaModal } from "./rana-modal";

// Makes sure portal is rendered insdie of parent modal
export function Portal({ children }: PortalProps) {
  try {
    const modalContext = useModalContext();
    return <ChakraPortal containerRef={modalContext?.dialogRef}>{children}</ChakraPortal>;
  } catch {
    return <ChakraPortal>{children}</ChakraPortal>;
  }
}

interface InfoModalProps extends Omit<ModalProps, "isOpen" | "onClose"> {
  type: "modal";
}

interface InfoPopoverProps {
  type: "popover";
}

type RanaExtraInfoProps = PropsWithChildren<InfoModalProps | InfoPopoverProps>;

export function RanaExtraInfo({ children, type, ...rest }: RanaExtraInfoProps) {
  const disclosure = useDisclosure();
  const popoverRef = useRef<HTMLDivElement | null>(null);

  const OpenButton = (props: ButtonProps) => {
    return (
      <Button rounded="full" boxSize="small_button" variant="tertiary" ref={popoverRef} {...props}>
        <InfoIcon />
      </Button>
    );
  };

  if (!children) return null;

  if (type === "modal")
    return (
      <>
        <OpenButton onClick={disclosure.onOpen} />
        <RanaModal pb={6} {...rest} {...disclosure}>
          {children}
        </RanaModal>
      </>
    );

  if (type === "popover")
    return (
      <Popover>
        <PopoverTrigger>
          <Box>
            <OpenButton />
          </Box>
        </PopoverTrigger>

        <Portal>
          <PopoverContent mr={2}>
            <PopoverArrow ml={1} />
            <PopoverCloseButton />
            <PopoverBody>{children}</PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    );

  return null;
}
